var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6497 20.9029L23.2469 21.5002C23.6765 21.9297 23.6765 22.6262 23.2469 23.0558L22.9358 23.3669C22.5062 23.7965 21.8097 23.7965 21.3802 23.3669L16.5224 18.5092C14.9245 19.6972 12.9444 20.4002 10.8002 20.4002C5.49826 20.4002 1.2002 16.1022 1.2002 10.8002C1.2002 5.49826 5.49826 1.2002 10.8002 1.2002C16.1022 1.2002 20.4002 5.49826 20.4002 10.8002C20.4002 13.0059 19.6563 15.0379 18.4058 16.659L20.0427 18.296C20.1935 18.4114 20.3373 18.5373 20.473 18.673L22.473 20.673C22.5422 20.7422 22.6014 20.8196 22.6497 20.9029ZM10.8002 18.0002C14.7766 18.0002 18.0002 14.7766 18.0002 10.8002C18.0002 6.82374 14.7766 3.6002 10.8002 3.6002C6.82374 3.6002 3.6002 6.82374 3.6002 10.8002C3.6002 14.7766 6.82374 18.0002 10.8002 18.0002Z",
    fill: "#031434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search_icon.c3201a31353f89d46c7c3d49858b553e.svg";
export { ForwardRef as ReactComponent };